import React, { useEffect } from "react";
import {asMoney, calcCampaignTotals} from "../../../../utils";
import { ExchangeRatesContext, useExchangeRatesContext } from '../../../../contexts/exchange-rates-context';
import {CurrencyField} from "../../../../components/CurrencyInput";
import {CampaignDiscountSelect} from "../../../../components/MaterialSelects/CampaignDiscountSelect";
import {FieldTable} from "../../../../components/FieldTable/FieldTable";
import {useAreaPricingContext, useDaybookContext} from "../../../../contexts/Daybook/DayBookContext";
import {variableCurrencyValue} from "../../../../components/field-table";
import { useUserContext } from "../../../../contexts/user-context";
import { useCampaignContext } from "../../../../contexts/campaign-context";
import { CampaignDiscountTextField } from "../../../../components/CampaignDiscountTextField";


const CampaignFinancialTable = (props) => {
  const trProps = (state, rowInfo) => {
    if (rowInfo.row.name.indexOf('Total') < 0) return {};
    return {
      style: {
        fontWeight: 'bold'
      }
    }
  };
  const getRowProps = ({data}) => {
    if(data?.name?.indexOf('Total')<0) return {};
    return {className:'row-total'}
  };
    const exchangeRatesContext = useExchangeRatesContext();
    //const currency = props.values.currency?props.values.currency.glyph:'£';
    const currency = props.values.currency;
    const daybookConfig = useDaybookContext();
    const calculateAreaBookingPricing = useCampaignContext().calculateAreaPricing;
    //console.log('C0',currency);
    const values = calcCampaignTotals({
      campaignValues:props.values,options:{isVatExempt:props.values?.is_vat_exempt},
      exchangeRates:exchangeRatesContext,
      daybookConfig:daybookConfig,
      calculateAreaBookingPricing:calculateAreaBookingPricing
    }
    );

    const columns = [{
      accessor: 'name',
      className: 'column-right',
      dataType:'default'
    }, {
      accessor: 'amount',
      className:'column-no-hide column-currency',
      dataType:'number',
      readOnly:true,
      options:{
        renderViewer: ({row,field}) => {
          const userContext = useUserContext();
          const isAdmin = userContext.user?.role?.name === "Admin Role" || userContext.user?.role?.name === "Man From Uncle Admin" || userContext.user?.role?.name === "Admin Role MFA" || userContext.user?.role?.name === "Admin Role + MFA";

          switch(row.name) {
            case 'Commission':
            case 'Discount':
              if(props.values.status=='Confirmed'||props.isReadOnly(true)) {
                return ((props.values.discount_percentage?props.values.discount_percentage:0).toString()+'%');
              }
            return (<CampaignDiscountSelect valueIsId={true} fullWidth={true} readOnly={props.readOnly} name="discount_percentage" isAdmin={isAdmin} salesTeam={props.values.salesTeam} value={props.values.discount_percentage} onChange={props.onChange}/>)
            case 'Discount (Good Will)':
              if(props.values.status=='Confirmed'||props.isReadOnly(true)) {
                return variableCurrencyValue({currency:currency,value:props.values.discount_final,places:2});
              }
              return (<CurrencyField readOnly={props.readOnly} fullWidth={true} currency={currency} name="discount_final" value={props.values.discount_final}
                onChange={(e) => {
                  const value = parseFloat(e.target.value);
                  if (!isAdmin && props.values.salesTeam?.prefix === "UUS" && value > 99999) {
                    e.target.value = 99999;
                  }
                  props.onChange(e); 
                }} />);
            default:
              return variableCurrencyValue({currency:currency,value:field.value,places:2});
          }
        }
      }
    }
    ];

    return <div className="grid12">
      <div className="grid12-6">
        <FieldTable hasExport={false}  loading={false}
        className="campaigns__summary__financial" readOnly={props.readOnly}
        values={values.values} columns={columns} hasDelete={false} showHeadings={false} getRowProps={getRowProps}/>
      </div>
      <div className="grid12-6">
        <FieldTable loading={false}
                className="campaigns__summary__financial" readOnly={props.readOnly}
        hasExport={false} values={values.valuesB} columns={columns} hasDelete={false} showHeadings={false} getRowProps={getRowProps}/>
          </div>
    </div>;
  }

export default CampaignFinancialTable;
